import { Component, OnDestroy, OnInit } from '@angular/core';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import * as moment from 'moment-timezone';
import { AssigTripsService } from '../assigntrips-service/assigntrips-service';
import { sweetAlert } from 'src/app/utils/swal';
import { exportToCsv, getBrokersList, getstandingOrderDaysAsObject } from 'src/app/utils/utils.common';
import { DatePipe } from 'src/app/pipe/date-pipe/date.pipe';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { Router, ActivatedRoute } from '@angular/router';
import { CorporateService } from '../../corporate-user/corporate-service/corporate-service';
import { LevelOfServiceService } from '../../level-of-service/service/level-of-service.service';
import { ServiceAreasService } from '../../service-areas/service-areas-service/service-areas.service';
import { FilterPipe } from 'src/app/pipe/list-filter-pipe/list-filter-pipe';
import { DriversService } from '../../drivers/drivers-service/drivers-service';
import * as _ from 'underscore';


@Component({
  selector: 'app-standing-orders-v2',
  templateUrl: './standing-orders-v2.component.html',
  styleUrls: ['./standing-orders-v2.component.css']
})
export class StandingOrdersV2Component implements OnInit, OnDestroy {
  standingOrderDays = getstandingOrderDaysAsObject();
  search: any;
  todayDate;
  timeZone;
  user;
  dataList = [];
  editTripModalObj;
  trip;
  corporateUsers = {};
  cloneTripModalObj;
  standingDetailModalObj;
  status = 'active';
  isShowDaysDropdown = false;
  standingDays = [
    { label: 'Sun', value: 0, isChecked: true },
    { label: 'Mon', value: 1, isChecked: true },
    { label: 'Tue', value: 2, isChecked: true },
    { label: 'Wed', value: 3, isChecked: true },
    { label: 'Thu', value: 4, isChecked: true },
    { label: 'Fri', value: 5, isChecked: true },
    { label: 'Sat', value: 6, isChecked: true },
  ];
  filteredCorporates = [];
  filterdataList = [];
  selectedCooperate = [];
  corporateList = [];

  preServiceAreas = {};
  preLevelOfServices = {};
  preSpaceTypes = {};
  preDriverList = {};
  tripLogObj;

  constructor(
    private sharedDataService: SharedDataService,
    private assignTripService: AssigTripsService,
    private dateP: DatePipe,
    private corporateService: CorporateService,
    private serviceArea: ServiceAreasService,
    private levelOfServiceService: LevelOfServiceService,
    private driverService: DriversService
    ) { }

  ngOnInit() {
    this.getUser();
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.timeZone = data.timeZone;
          this.user = data;
          this.todayDate = moment.tz(this.timeZone).startOf('day').toISOString();
          this.getCorporateUserList();
          this.getDriverList();
          this.getTrips();
        }
      });
  }

  getCorporateUserList() {
    this.assignTripService
      .getCorporateUserList()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.corporateList = data;
          this.corporateUsers = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      });
      this.getServiceAreas();
  }

  getTrips() {
    this.assignTripService.getAssignManifestList({
      status: 'standing',
      isRecurring: this.status === 'active' ? true : false
    })
    .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        this.dataList = [];
        if (data) {
          this.dataList = data;
          let cooperates = [];

          this.dataList.forEach(s => {
            s.diffFromToday = 10;
            if (s.recurringEndDate) {
              const end = moment(s.recurringEndDate, 'YYYY-MM-DD').tz(this.timeZone);
              const now = moment(this.todayDate).tz(this.timeZone);
              s.diffFromToday = end.diff(now, 'days');
            }

            if (s.cooperate) {
              cooperates.push(s.cooperate);
            }

          });
          cooperates = _.uniq(cooperates).sort();
          if (cooperates && cooperates.length) {
            this.filteredCorporates = this.corporateList.filter(c => cooperates.includes(c._id));
          }
          this.dataList.sort((a, b) => a.diffFromToday - b.diffFromToday);
          this.filterTripsByModel();

        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }


    filterTripsByModel() {
      this.filterdataList = this.dataList;
      this.filterdataList = new FilterPipe().transform(
        this.filterdataList,
        this.search
      );

      this.filterByFSTrips();
      this.onChangeDays();
    }


  filterByFSTrips() {
    this.filterdataList = this.filterdataList.filter(trip => {
      let isCorporateExist = true;
      if (this.selectedCooperate && this.selectedCooperate.length) {
        if (trip.cooperate) {
          isCorporateExist = this.selectedCooperate.includes(trip.cooperate);
        } else {
          isCorporateExist = false;
        }
      }

      if (isCorporateExist) {
        return true;
      } else {
        return false;
      }
    });
  }

  editTrip(assign) {
    if (this.cloneTripModalObj) return;
    if (this.standingDetailModalObj) return;
    if (this.tripLogObj) return;
    this.editTripModalObj = assign._id;
    this.trip = assign;

  }

  onEditTrip(event) {
    this.editTripModalObj = null;
    this.trip = null;
    this.getTrips();
  }

  getCorporateByID(id) {
    return this.corporateUsers[id];
  }

  brokerList(key?) {
    if (key) {
      return getBrokersList[key];
    }
    return getBrokersList;
  }

  openCloneModal(trip) {
    this.cloneTripModalObj = trip;
  }

  closeCloneTripModal(evt) {
    this.cloneTripModalObj = null;
  }

  openStandingDetailModal(trip) {
    this.standingDetailModalObj = trip;
  }

  openTripLog(assign) {
    this.tripLogObj = assign;
  }

  closeStandingDetailModal(evt) {
    this.standingDetailModalObj = null;
  }

  onChangeDays() {
    let days = [];
    this.standingDays.forEach(d => {
      if (d.isChecked) {
        days.push(d.value);
      }
    });

    if (days.length === 0) {
      this.filterdataList = this.filterdataList;
      return;
    }
    this.filterdataList = this.filterdataList.filter(s => s.recurringDays.some(r => days.includes(r.day)));

  }

  onChangeStatus() {
    this.getTrips();
  }

  downloadReport() {
    const table = [
      [
        "Trip ID",
        "Member",
        "PU Time",
        "Apt Time",
        "Pickup",
        "Dropoff",
        "LOS",
        "Type",
        "Days",
        "Assigned Drivers",
        "Status",
        "End Date"
      ]
    ];

    for (let i = 0; i < this.dataList.length; i++) {
      const trip = this.dataList[i];

      let type = '';
      if(trip.jobType === 'cooperate') {
        if (trip.cooperate) {
          const corp = this.getCorporateByID(trip.cooperate);
          type = corp ? corp.displayName : "None"
        } else {
          type = "None";
        }
      } else {
        type = trip.companyType === "" ? "Cab Dispatch" : this.brokerList(trip.companyType);
      }

      let days = '';
      days = trip.recurringDays.map(r => {
        return this.standingOrderDays[r.day]
      });
      days = days && days.length ? days.toString() : '';

      let assignedDrivers: any = trip.recurringDays.filter((r: any) => r.driver).map((r: any) => {
        const driver = this.getDriverByID(r.driver);
        const driverName = driver ? driver.displayName : "N/A";
        return `${this.standingOrderDays[r.day]}: ${driverName}`;
      });
      assignedDrivers = assignedDrivers && assignedDrivers.length ? assignedDrivers.toString() : "Unassigned";

      const standingOrder = [
        trip.tripId,
        trip.priorityClient ? trip.priorityClient.displayName : "N/A",
        this.dateP.transform(trip.scheduleTime, "HH:mm"),
        this.dateP.transform(trip.appointmentTime, "HH:mm"),
        trip.jobOriginAddress,
        trip.jobDestinationAddress,
        trip.tripRequirement,
        type,
        days,
        assignedDrivers,
        trip.isRecurring ? "Active": "Inactive",
        trip.recurringEndDate ? this.dateP.transform(trip.recurringEndDate, "MM/DD/YYYY") : "N/A"
      ]
      table.push(standingOrder);
    }
    exportToCsv(`standing-orders-${ moment().format("MM-DD-YYYY")}.csv`, table);
  }

  toggleDaysDropdown() {
    this.isShowDaysDropdown = !this.isShowDaysDropdown
  }

  getServiceAreas(){
    this.serviceArea.getServiceAreas({status: 'active'})
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.preServiceAreas = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "Ok");
        }
      );
      this.getLevelOfService();
    }

    getLevelOfService() {
      this.levelOfServiceService
        .getLevelOfServices({status: 'active'})
        .subscribe(data => {
          if (data) {
            this.preLevelOfServices = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
          }
        }, err => {
          sweetAlert("Error", err, "error", "Ok");
        });
        this.getSpaceTypes();
    }

    getSpaceTypes() {
      this.levelOfServiceService
        .getSpaceTypes({status: 'active'})
        .subscribe(data => {
          if (data) {
            this.preSpaceTypes = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
          }
        }, err => {
          sweetAlert("Error", err, "error", "Ok");
        });
    }

  getDriverList() {
    this.driverService.getDrivers(this.user._id, "active")
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.preDriverList = data.reduce((obj: any, item: any) => (obj[item._id] = item, obj), {});
        }
      });
  }

  getDriverByID(id) {
    return this.preDriverList[id];
  }

  ngOnDestroy(): void {
  }
}
